// extracted by mini-css-extract-plugin
export default {"cta":"CTA_cta__tQVOM"};